export default __webpack_public_path__ + "1a157d37a0779c7e7ddee2d8c5bc17ae.svg";